// Conversion utility functions

import { unitsByCategory } from '../data/mock';

// Temperature conversions
export const convertTemperature = (value, from, to) => {
  if (from === to) return value;
  
  // Convert to Celsius first
  let celsius;
  switch (from) {
    case 'celsius':
      celsius = value;
      break;
    case 'fahrenheit':
      celsius = (value - 32) * 5 / 9;
      break;
    case 'kelvin':
      celsius = value - 273.15;
      break;
    case 'rankine':
      celsius = (value - 491.67) * 5 / 9;
      break;
    default:
      celsius = value;
  }
  
  // Convert from Celsius to target
  switch (to) {
    case 'celsius':
      return celsius;
    case 'fahrenheit':
      return (celsius * 9 / 5) + 32;
    case 'kelvin':
      return celsius + 273.15;
    case 'rankine':
      return (celsius + 273.15) * 9 / 5;
    default:
      return celsius;
  }
};

// Standard unit conversion using factors
export const convertUnit = (value, fromUnit, toUnit, category) => {
  if (category === 'temperature') {
    return convertTemperature(value, fromUnit, toUnit);
  }
  
  const units = unitsByCategory[category];
  if (!units) return value;
  
  const from = units.find(u => u.id === fromUnit);
  const to = units.find(u => u.id === toUnit);
  
  if (!from || !to) return value;
  
  // Convert to base unit then to target
  const baseValue = value * from.factor;
  return baseValue / to.factor;
};

// Format large/small numbers
export const formatNumber = (num) => {
  if (num === 0) return '0';
  if (Math.abs(num) < 0.000001 || Math.abs(num) > 1000000000) {
    return num.toExponential(6);
  }
  // Round to 10 decimal places and remove trailing zeros
  const rounded = parseFloat(num.toPrecision(10));
  return rounded.toString();
};
